<template>
    <div class="ur-data-grid__context" :style="contextStyle" :class="contextClass" v-if="isOpen" v-click-outside="close">
        <template v-for="(ctx, idx) in contexts">
            <div class="ur-data-grid__context__separator" :key="'sep-'+idx" v-if="ctx.separator"/>
            <div class="ur-data-grid__context__item" :key="'item-'+idx" @click="onClick(ctx)" v-else>
                <ur-icon :icon="ctx.icon" v-if="ctx.icon"/>
                <div class="ur-data_grid__context__item__text">{{ctx.text}}</div>
            </div>
        </template>
    </div>
</template>


<script>
import clickOutside from '../../common/direc/urDataGridClickOutside.js'
export default {
    name : 'urDataGridContext',
    inject : ['gridInfo'],
    data() {return {
        isOpen : false,
        contexts : [],
        pos : {},
        value   : {}, // tempArgs -> openMethod to onClick callback
        rowInfo : {}, // tempArgs -> openMethod to onClick callback
    }},
    computed : {
        contextStyle() {
            var style = {}, p = this.pos;
            if(p.left)   style['left']   = `${p.left}px`;
            if(p.right)  style['right']  = `calc(100% - ${p.right}px)`;
            if(p.top)    style['top']    = `${p.top}px`;
            if(p.bottom) style['bottom'] = `calc(100% - ${p.bottom}px)`;
            return style
        },
        contextClass() {
            return {'ur-data-grid__context--no-icon':this.gridInfo.opts.noContextIcon}
        }
    },
    methods : {
        open(val, row, ctxs, pos) {
            this.isOpen = true;
            this.contexts = ctxs;
            this.pos = pos;
            this.__val = val;
            this.__row = row;

        },
        close() {
            this.isOpen = false;
        },
        onClick(ctx) {
            if(typeof ctx.action === 'function') {
                ctx.action(this.__val, this.__row); // not reactive...
            } else if(typeof ctx.action === 'string') {
                this.gridInfo.func.fireEvent('context:'+ctx.action, this.__val, this.__row);
            }
            this.close();
        }
    },
    directives: {'click-outside': clickOutside}
}
</script>

